<template>
  <ul class="pagination pagination-sm no-margin pull-right">
    <li class="paginate_button previous">
      <button :disabled="pagination.current_page === 1" class="paginate_button previous" @click.prevent="$parent.paginate('page','previous')">{{'previous' | translate | capitalize}}</button>
    </li>
    <template v-for="n in chunk">
      <li class="paginate_button">
        <button :key="`button-${n}`" :class="[pagination.current_page === n ? 'active' : '', 'paginate_button', 'page-link']" @click.prevent="log(n)">{{n === 'x' || n === 'y' || n === 'z' ? '...' : n}}</button>
      </li>
    </template>
    <li :disabled="pagination.last_page === pagination.current_page">
      <button class="paginate_button next" :disabled="pagination.last_page === pagination.current_page" @click.prevent="$parent.paginate('page','next')">{{'next' | translate | capitalize}}</button>
    </li>
  </ul>
</template>
<script>
export default {
  props: ['total', 'perPage', 'pagination'],
  data () {
    return {
      chunk: []
    }
  },
  methods: {
    updateChunk () {
      if (this.numberOfPages >= 10) {
        if (this.pagination.current_page < 4) {
          this.chunk = [1, 2, 3, 4, 'z', this.numberOfPages]
        } else if (this.pagination.current_page >= this.numberOfPages - 3) {
          this.chunk = [1, 'x', this.numberOfPages - 2, this.numberOfPages - 1, this.numberOfPages]
        } else {
          this.chunk = [1, 'x', this.pagination.current_page - 1, this.pagination.current_page, this.pagination.current_page + 1, 'y', this.numberOfPages]
        }
      } else {
        this.chunk = this.numberOfPages
      }
    },
    log (n) {
      if (n === 'x') {
        this.$parent.paginate('page', this.pagination.current_page - 3)
      } else if (n === 'y') {
        this.$parent.paginate('page', this.pagination.current_page + 3)
      } else if (n === 'z') {
        this.$parent.paginate('page', this.pagination.current_page + 1)
      } else {
        this.$parent.paginate('page', n)
      }
    }
  },
  computed: {
    numberOfPages () {
      const result = Math.ceil(this.total / this.perPage)
      return (result < 1) ? 1 : result
    }
  },
  mounted: function () {
    this.updateChunk()
  },
  watch: {
    pagination: function () {
      this.updateChunk()
    }
  }
}
</script>
